import { auth, functions } from './Firebase';
import {httpsCallable} from "firebase/functions";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useState } from "react";

export default function Step10ExistingAccount({email, isShow, setEmailSubmitted, setStep, setVhxId}) {
  const [isLoading, setIsLoading] = useState(false);

  async function handleSubmit(emailSubmitted) {
    // Set loading
    setIsLoading(true);

    // Check if email address exists in vhx
    const user = auth.currentUser;
    const idToken = await user.getIdToken();
    const vhxQueryCustomerEmail = httpsCallable(functions, 'vhxQueryCustomerEmail');
    if ( idToken ) {
      const results = await vhxQueryCustomerEmail({
        "idToken": idToken,
        "email": emailSubmitted,
      });
      if (results) {
        const data = results.data;
        setEmailSubmitted(emailSubmitted);

        // TODO: testing force error
        // setStep(5);
        
        if ( data.count === 1) {
          // If 1 results: step 6 confirm add products to account
          setVhxId(data.vhx_id);
          setStep(12);
        } else if ( data.count === 0 ) {
          // If 0 results: "is this right email/account?" "can we create?"
          setStep(11);
        } else {
          // Error
          // If +1 results: something weird is going on click button to submit issue
          setStep(8);
        }
        
        // Set not loading
        setIsLoading(false);
      }
    }
  }

  if ( isShow ) {
    if ( isLoading ) {
      return (
        <div className="step">
          One moment. We're looking up your account. <div className="spinner-inline" />
        </div>
      )
    } else {
      return (
        <div className={"step choose-email"}>
          What email address does<br/>
          your Gizmoplex account use?<br/>
          <Formik
            enableReinitialize={true} // enableReinitialize prop resets form only if initialValues is changed
            initialValues={{ 
              email: email || "",
            }}
            // Validation rules
            validate={values => {
              const errors = {};
              // EMAIL
              if ( !values.email ) {
                // Email is required
                errors.email = 'Required';
              } else if (
                // Validate email
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
              ) {
                errors.email = 'Invalid email address';
              }
              return errors;
            }}

            // Submit actions
            onSubmit={(values, { resetForm, setSubmitting }) => {
                setSubmitting(true);

                setTimeout(() => {
                  // Submit form
                  handleSubmit(values.email);

                  // Re-enable buttons
                  setSubmitting(false);
                }, 400);
            }}
          >
            {({ isSubmitting, resetForm }) => (
              <Form className="">
                <div className={"form-card"}>
                  <label htmlFor="email"></label>
                  <Field className="form-input" id="email"name="email" type="email" />
                  <ErrorMessage className="error-message" component="div" name="email" />
                </div><br/>
                <button className="button-blue">Continue</button>
              </Form>
            )}
          </Formik>
        </div>
      );
    }
  } else {
    return (<></>);
  }
}
    